export const PaymentCycleCode = [
  { label: '当月', value: '1' },
  { label: '翌月', value: '2' },
  { label: '翌々月', value: '3' },
  { label: '３ヵ月', value: '4' },
  { label: '４ヵ月', value: '5' },
  //{ label: '５ヵ月', value: '6' },
  //{ label: '６ヵ月', value: '7' },
];
